const ChatOptionButtons = ({
  options = [],
  onSelect,
  disabled = false,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        gap: '10px',
        width: '100%',
        justifyContent: 'center',
        flexWrap: 'wrap',
      }}
    >
      {options.map((option) => {
        const isObject = typeof option === 'object'

        const key = isObject ? option.value : option
        const label = isObject ? option.label : option
        const value = isObject ? option.value : option

        return (
          <button
            key={key}
            type='button'
            className='upload-send-btn'
            onClick={() => onSelect(value, label)}
            disabled={disabled}
            style={{ minWidth: '120px' }}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}

export default ChatOptionButtons